<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm văn phòng liên kết</div>
      <div v-else>Chỉnh sửa văn phòng liên kết</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm VPLK'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã VP liên kết*</label>
            <div class="p-col-8">
              <InputText v-model="code"  id="code" type="text" class="p-col-width" placeholder="Nhập mã Văn Phòng Liên Kết" />
              <small
                v-if="validationErrors && validationErrors['code']"
                class="p-invalid"
              >{{validationErrors['code']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã số thuế</label>
            <div class="p-col-8">
              <InputText v-model="tax_code"  id="tax_code" type="text" class="p-col-width" placeholder="Nhập mã số thuế" />
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Tên VP liên kết*</label>
            <div class="p-col-8">
              <InputText v-model="name"  id="name" type="text" class="p-col-width" placeholder="Nhập tên VP liên kết" />
              <small
                v-if="validationErrors && validationErrors['name']"
                class="p-invalid"
              >{{validationErrors['name']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Số điện thoại</label>
            <div class="p-col-8">
              <InputMask  v-model="phone"  mask="9999999999" id="phone" type="text" class="p-col-width" placeholder="Nhập số điện thoại" />
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Địa chỉ</label>
            <div class="p-col-8">
              <InputText v-model="address"  id="address" type="text" class="p-col-width" placeholder="Nhập địa chỉ" />
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã văn phòng TPL*</label>
            <div class="p-col-8">
              <MultiSelect v-model="selectedOfficeTpl" :options="this.listOfficeTpl" 
              optionLabel="code" placeholder="Chọn mã văn phòng TPL" :filter="true">
              </MultiSelect>
              <small
                v-if="validationErrors && validationErrors['office_tpl']"
                class="p-invalid"
              >{{validationErrors['office_tpl']}}</small>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Ngân hàng</label>
            <div class="p-col-8">
              <Dropdown id="bank_id" :showClear="true" :filter="true"
              v-model="bank_id" :options="list_bank" optionLabel="name"
              placeholder="Chọn ngân hàng"/>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Chủ tài khoản</label>
            <div class="p-col-8">
              <InputText v-model="account_holder"  id="account_holder" type="text" class="p-col-width" placeholder="Nhập chủ tài khoản" />
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Số tài khoản</label>
            <div class="p-col-8">
              <InputText v-model="account_number"  id="account_number" type="number" class="p-col-width" placeholder="Nhập số tài khoản" />
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
import graphql from "@/views/admin/common/graphql";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      address: '',
      name: '',
      tax_code: '',
      code: '',
      phone: '',
      listOfficeTpl: [],
      selectedOfficeTpl: [],
      listOfficeVplk: [],
      bank_id: null,
      list_bank: [],
      account_holder: '',
      account_number: ''
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.office_vplk_id = this.$route.params.id
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      console.log('-------------------------------', this.selectedOfficeTpl)
      this.validationErrors = {};
      var has_error = false
      if (this.name === '') {
        this.validationErrors['name'] = 'Vui lòng nhập tên văn phòng liên kết';
        has_error = true
      }
      if (this.selectedOfficeTpl.length == 0) {
        this.validationErrors['office_tpl'] = 'Vui lòng chọn mã văn phòng TPL';
        has_error = true
      }
      if (this.code === '') {
        this.validationErrors['code'] = 'Vui lòng nhập mã văn phòng liên kết';
        has_error = true
      } else {
        if (this.mode == 'add') {
          let query = `query MyQuery($code: String) {
            office_vplk(where: {code: {_like: $code}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.office_vplk[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã văn phòng liên kết bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            })
        } else {
          let query = `query MyQuery($code: String, $id: Int) {
            office_vplk(where: {code: {_like: $code}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.office_vplk[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã văn phòng bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            }) 
        }
      }
      return has_error
    },
    async analyzeData() {
      console.log('dâdadadadadadad')
      var data_office_vplk = {}
        data_office_vplk['tax_code'] = this.tax_code
        data_office_vplk['name'] = this.name
        data_office_vplk['code'] = this.code
        data_office_vplk['phone'] = this.phone
        data_office_vplk['address'] = this.address
        data_office_vplk['account_holder'] = this.account_holder
        //data_office_vplk['account_holder'] = this.address
        //data_office_vplk['account_number'] = this.address
        data_office_vplk['account_number'] = this.account_number
        data_office_vplk['bank_id'] = this.bank_id.id

        var data_item= []

        for (let i = 0; i < this.selectedOfficeTpl.length; i++) {
          const item = this.selectedOfficeTpl[i]
          var data_item_item= {}
          data_item_item['office_tpl_id'] = item.id
          data_item.push(data_item_item)
        }
        var data_office_vplk_item = {}
        data_office_vplk_item['data'] = data_item
        data_office_vplk['office_vplk_tpls'] = data_office_vplk_item

      return data_office_vplk
    },
    async analyzeDataEdit() {
      var data_office_vplk = {}
        data_office_vplk['tax_code'] = this.tax_code
        data_office_vplk['name'] = this.name
        data_office_vplk['code'] = this.code
        data_office_vplk['phone'] = this.phone
        data_office_vplk['address'] = this.address
        //data_office_vplk['account_holder'] = this.address
        //data_office_vplk['account_number'] = this.address
        data_office_vplk['account_holder'] = this.account_holder
        data_office_vplk['account_number'] = this.account_number
        data_office_vplk['bank_id'] = this.bank_id.id
      return data_office_vplk
    },
    async analyzeDataEditItem() {
      var data_item= []
      for (let i = 0; i < this.selectedOfficeTpl.length; i++) {
          const item = this.selectedOfficeTpl[i]
          var data_item_item= {}
          data_item_item['office_vplk_id'] = this.office_vplk_id
          data_item_item['office_tpl_id'] = item.id
          data_item.push(data_item_item)
        }
      return data_item
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_office_vplk = await this.analyzeData()

        var query = `mutation MyMutation($objects: [office_vplk_insert_input!]!) {
            insert_office_vplk(objects: $objects) {
              affected_rows
              returning {
                id
                name
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_office_vplk]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-office_vplk'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_office_vplk_update = await this.analyzeDataEdit()
        let data_office_vplk_item = await this.analyzeDataEditItem()
        let query = `mutation MyMutation($office_vplk_id: Int!, $office_vplk_update: office_vplk_set_input, $objects: [office_vplk_tpl_insert_input!]!) {
          update_office_vplk(where: {id: {_eq: $office_vplk_id}}, _set: $office_vplk_update) {
            affected_rows
            returning {
              id
              name
            }
          }
          delete_office_vplk_tpl(where: {office_vplk_id: {_eq: $office_vplk_id}}) {
            affected_rows
          }
          insert_office_vplk_tpl(objects: $objects) {
            affected_rows
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              office_vplk_id: this.office_vplk_id,
              office_vplk_update: data_office_vplk_update,
              objects: data_office_vplk_item
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-office_vplk'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    office_tpl: {
      query() {
        let query = graphql.GET_OFFICE_TPL_COMMON
        return gql(query);
      },
      update(data) {
        if(data.office_tpl){
          this.listOfficeTpl = data.office_tpl
        }
      },
      fetchPolicy: "network-only",
    },
    bank: {
      query() {
        let query = `
          query MyQuery {
            bank {
              id
              name
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.bank){
          this.list_bank = data.bank
        }
      },
      fetchPolicy: "network-only",
    },
    office_vplk: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            office_vplk(where: {id: {_eq: $id}}) {
              id
              name
              code
              phone
              address
              tax_code
              account_holder
              account_number
              bank {
                id
                name
              }
              office_vplk_tpls {
                office_tpl {
                  id
                  code
                }   
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
        if(data.office_vplk){
          this.listOfficeVplk = data.office_vplk
          this.name = this.listOfficeVplk[0].name
          this.code = this.listOfficeVplk[0].code
          this.tax_code = this.listOfficeVplk[0].tax_code
          this.phone = this.listOfficeVplk[0].phone
          this.address = this.listOfficeVplk[0].address
          this.account_holder = this.listOfficeVplk[0].account_holder
          this.account_number = this.listOfficeVplk[0].account_number
          this.bank_id = this.listOfficeVplk[0].bank
          if (this.listOfficeVplk[0].office_vplk_tpls.length >0) {
            for (let i = 0; i < this.listOfficeVplk[0].office_vplk_tpls.length; i++) {
              const e = this.listOfficeVplk[0].office_vplk_tpls[i];
              this.selectedOfficeTpl.push({id: e.office_tpl.id, code: e.office_tpl.code, __typename: "office_tpl"})
            }
          }
          console.log('ddddddddd', this.selectedOfficeTpl)
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
